import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

export default function ActiveVendorRouteGuard({ children }) {
  const { user, loading: authLoading } = useAuth();
  const [seller, setSeller] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    let mounted = true;

    const checkSeller = async () => {
      if (authLoading) return;

      if (!user || user.role !== "vendor") {
        if (mounted) setChecking(false);
        return;
      }

      try {
        const response = await api.get("/vendor/me");

        if (mounted) {
          setSeller(response.data);
        }
      } catch {
        if (mounted) {
          setSeller(null);
        }
      } finally {
        if (mounted) {
          setChecking(false);
        }
      }
    };

    checkSeller();

    return () => {
      mounted = false;
    };
  }, [user, authLoading]);

  if (authLoading || checking) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#F4F7F6]">
        <div className="text-sm text-[#66766D]">
          Checking partner approval...
        </div>
      </div>
    );
  }

  if (!user || user.role !== "vendor") {
    return <Navigate to="/vendor/login" replace />;
  }

  if (!seller || seller.status !== "active") {
    return <Navigate to="/vendor/business-profile" replace />;
  }

  return children;
}
